<div id="team-page">
  <swoosh [text]="swooshText" [external]="swooshExternal"></swoosh>
  <profile-header></profile-header>
  <div class="d-block d-md-none purple-swoosh"></div>

  <div *ngIf="!isShowingEmptyState()">
    <div class="desktop d-none d-md-block d-lg-block d-xl-block" *ngIf="isDesktopLayout; else mobileLayout">
      <div class="navigation">
        <nav ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs container nav-pills nav-justified">
          <ng-container ngbNavItem="TeamMembers">
            <a ngbNavLink (click)="selectContent('TeamMembers')" class="no-margins">Team Members</a>
            <ng-template ngbNavContent>
              <app-team-teammembers *ngIf="!isShowingEmptyState(); else desktopLockedDownView"></app-team-teammembers>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="Dichotomies">
            <a ngbNavLink (click)="selectContent('Dichotomies')" class="no-margins">Preference Pairs</a>
            <ng-template ngbNavContent>
              <app-team-dichotomies *ngIf="!isShowingEmptyState(); else desktopLockedDownView"></app-team-dichotomies>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="Compare">
            <a ngbNavLink (click)="selectContent('Compare')" class="no-margins">Compare</a>
            <ng-template ngbNavContent>
              <app-team-compare *ngIf="!isShowingEmptyState(); else desktopLockedDownView"></app-team-compare>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="TeamInsights">
            <a ngbNavLink (click)="selectContent('TeamInsights')" class="no-margins">Team Insights</a>
            <ng-template ngbNavContent>
              <app-team-teaminsights *ngIf="!isShowingEmptyState(); else desktopLockedDownView"></app-team-teaminsights>
            </ng-template>
          </ng-container>
        </nav>
      </div>
      <div [ngbNavOutlet]="nav" class="container mt-2"></div>
    </div>
  </div>

  <ng-template #mobileLayout>
    <div class="mobile container d-block d-md-none">
      <div class="dropdown">
        <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
          <button class="btn-primary" id="dropdownManual" ngbDropdownAnchor (click)="myDrop.open()">{{ chosenDropDown }}</button>
          <div ngbDropdownMenu aria-labelledby="dropdownManual">
            <button ngbDropdownItem class="dropdown-item" (click)="selectContent('Team Members')">Team Members</button>
            <button ngbDropdownItem class="dropdown-item" (click)="selectContent('Dichotomies')">Preference Pairs</button>
            <button ngbDropdownItem class="dropdown-item" (click)="selectContent('Compare')">Compare</button>
            <button ngbDropdownItem class="dropdown-item" (click)="selectContent('TeamInsights')">Team Insights</button>
          </div>
        </div>
      </div>
      <div class="container team-content">
        <div class="" name="teamMembers" *ngIf="showTeamMembers" aria-labelledby="teamMembers-tab"><app-team-teammembers></app-team-teammembers></div>
        <div class="" name="dichotomies" *ngIf="showDichotomies" aria-labelledby="dichotomies-tab"><app-team-dichotomies></app-team-dichotomies></div>
        <div class="" name="compare" *ngIf="showCompare" aria-labelledby="compare-tab"><app-team-compare></app-team-compare></div>
        <div class="" name="teamInsights" *ngIf="showTeamInsights" aria-labelledby="teamInsights-tab">
          <app-team-teaminsights></app-team-teaminsights>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #desktopLockedDownView>
    <div class="container locked-down-void"></div>
  </ng-template>
</div>
